module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-event-item linked-item"
  }, [_c('div', {
    staticClass: "contact-event-icon comment-icon"
  }), _c('div', {
    staticClass: "contact-event-header"
  }, [_c('span', {
    staticClass: "contact-event-title"
  }, [_vm._v("Comentado por " + _vm._s(_vm.event.author))]), _c('span', {
    staticClass: "contact-event-time"
  }, [_vm._v("em " + _vm._s(_vm.event.created_at.format('LLL')) + ".")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.has_edition),
      expression: "has_edition"
    }],
    staticClass: "contact-event-title",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.event.updated_at.format('DD/MM/YYYY [às] HH:mm')
    }
  }, [_vm._v("Última edição: " + _vm._s(_vm.event.edition_author))]), _c('div', {
    staticClass: "clearfix"
  }), (!_vm.showSummernote) ? _c('div', {
    staticClass: "contact-event-description clickable",
    on: {
      "click": function($event) {
        return _vm.toogleSummernote()
      }
    }
  }, [_vm._v(_vm._s(_vm.short_description))]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSummernote),
      expression: "showSummernote"
    }],
    staticClass: "contact-event-summernote"
  }, [_c('textarea', {
    attrs: {
      "id": _vm.element_id
    }
  }), _c('div', {
    staticClass: "add-comment-click comment-buttons"
  }, [_c('button', {
    staticClass: "btn btn-gray",
    on: {
      "click": function($event) {
        _vm.showSummernote = !_vm.showSummernote
      }
    }
  }, [_vm._v("Cancelar")]), (_vm.user_can_edit) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.removeComment()
      }
    }
  }, [_vm._v("Excluir")]) : _vm._e(), (_vm.user_can_edit) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.updateComment()
      }
    }
  }, [_vm._v("Salvar")]) : _vm._e()])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSummernote),
      expression: "!showSummernote"
    }],
    staticClass: "glyphicon glyphicon-trash delete-event-btn clickable",
    on: {
      "click": _vm.removeComment
    }
  })]), _c('div', {
    staticClass: "clear"
  }), _c('confirm-modal', {
    attrs: {
      "id": _vm.modal_id,
      "title": "Excluir comentário",
      "message": "Deseja realmente excluir este comentário?",
      "confirm_text": "Sim, excluir",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.confirmRemoveComment
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d1054460!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/events/comment_event.vue
// module id = 1218
// module chunks = 1